/**
 * @param {?} value
 * @param {?} index
 * @return {?}
 */
export function Ly_Next(value, index) {
    var /** @type {?} */ nxt = value;
    var /** @type {?} */ i = index;
    var /** @type {?} */ length = nxt.length;
    var /** @type {?} */ _index;
    // let part = index / length;
    if ((i + 1) < length) {
        nxt = (nxt[(i + 1)]);
        _index = i + 1;
    }
    else {
        _index = 0;
        nxt = (nxt[(0)]);
    }
    return {
        index: _index,
        next: nxt,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/array/next.js
// module id = 1369
// module chunks = 31